// extracted by mini-css-extract-plugin
module.exports = {"wrap":"OfferSentStatus_wrap__1j8dN","status":"OfferSentStatus_status__WnQAY"};